import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getReferencePath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/reference",
		[Locale.en]: "/reference",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
